export const BrokenComponent = () => {
  throw new Error("test error");
  // eslint-disable-next-line no-unreachable
  return <p>test</p>;
};

export default {};
